import { create } from 'zustand';

const KEY = 'poke_cart_v1';

function load() {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
}
function save(items) { localStorage.setItem(KEY, JSON.stringify(items)); }

export const useCart = create((set, get) => ({
  items: load(),
  add: (item) => {
    const items = [...get().items, { ...item, id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}` }];
    set({ items }); save(items);
  },
  updateQty: (id, qty) => {
    const items = get().items.map(i => i.id === id ? { ...i, quantity: Math.max(1, qty) } : i);
    set({ items }); save(items);
  },
  /**
   * Replace the payload of an existing cart line while keeping its id.
   * Used by the "Modifica" flow: the Builder re-opens with the current
   * composition, the user edits it, and on save we overwrite in place
   * instead of appending a new line.
   */
  replace: (id, item) => {
    const items = get().items.map(i => i.id === id ? { ...item, id } : i);
    set({ items }); save(items);
  },
  findById: (id) => get().items.find(i => i.id === id) || null,
  remove: (id) => {
    const items = get().items.filter(i => i.id !== id);
    set({ items }); save(items);
  },
  clear: () => { set({ items: [] }); save([]); },
  totalItems: () => get().items.reduce((n, i) => n + i.quantity, 0),
  subtotal: () => get().items.reduce((n, i) => n + i.unit_price * i.quantity, 0),
}));
